var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"logo"},[_c('img',{attrs:{"src":"https://iklan.sircledev.com/public/dist/logo.jpeg","width":"160"}})])
}]

export { render, staticRenderFns }